import { Box, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import classes from "../style";
import CoachPlanning from "./CoachPlanning";
import CoachResume from "./CoachResume";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CoachMainPage: React.FC = () => {
  const [update1, setUpdate1] = useState(0);

  const [update2, setUpdate2] = useState(0);

  const updatePlanning = () => {
    setUpdate1((update1 + 1) % 1000);
    setUpdate2((update2 + 1) % 1000);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    updatePlanning();
  };

  return (
    <>
      <Box sx={classes.coachMainPage}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Mes séances" {...a11yProps(0)} />
          <Tab label="Mes disponibilités" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CoachResume needUpdate={update2} triggerUpdate={updatePlanning} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CoachPlanning triggerUpdate={updatePlanning} needUpdate={update2} />
      </TabPanel>
    </>
  );
};

export default CoachMainPage;
